import { Button } from "@components/button";
import React, { ReactNode, memo, useCallback, useEffect, useState } from "react";
import "./toast.scss";
import { CheckFillIcon, CloseIcon, RemoveFillIcon } from "@components/icons";
import { DEFAULT_TOAST_DELAY, DEFAULT_TOAST_VISIBILITY_DURATION } from "@constants/generic";

export interface ToastProps {
  id: string;
  destroy: (id: string) => void;
  title: string;
  content: ReactNode;
  duration?: number;
  variant: "danger" | "success";
  disableAutoClose?: boolean;
}

const ToastComponent: React.FC<ToastProps> = ({
  destroy,
  content,
  title,
  duration,
  id,
  variant,
  disableAutoClose,
}) => {
  const [active, setActive] = useState<boolean>(false);

  useEffect(() => {
    setActive(true);
    if (disableAutoClose) {
      return;
    }

    const timer = setTimeout(() => {
      setActive(false);
      setTimeout(() => {
        destroy(id);
      }, DEFAULT_TOAST_DELAY);
    }, duration ?? DEFAULT_TOAST_VISIBILITY_DURATION);

    return () => clearTimeout(timer);
  }, [destroy, duration, id, disableAutoClose]);

  const closeToast = useCallback(
    (id: string) => {
      setActive(false);
      setTimeout(() => {
        destroy(id);
      }, DEFAULT_TOAST_DELAY);
    },
    [destroy],
  );

  return (
    <div className={`toast ${variant} ${active ? "active" : ""}`}>
      <h3>
        {variant === "success" && <CheckFillIcon size="25" color="#0c8c43" />}
        {variant === "danger" && <RemoveFillIcon size="25" color="#e53332" />} {title}
      </h3>
      <p>{content}</p>

      <Button
        onClick={() => {
          closeToast(id);
        }}
        className="toast-close"
      >
        <CloseIcon color="#363636" size={14} />
      </Button>
    </div>
  );
};

export const Toast = memo(ToastComponent);
